import React from 'react';

import { StyledSummary } from './styles';

const Sumary = ({ query, total }) => {
  const message = `${total} Support Article${total > 1 ? 's' : ''} for "${query}"`;

  return <StyledSummary>{message}</StyledSummary>;
};

export default Sumary;
